module.exports = __webpack_public_path__ + "static/media/353507841_646801013986889_90348826546573505_n-removebg-preview.d89993d6.png";